import React, {useRef, useEffect, ReactNode } from 'react';

interface DropdownProps {
  onClose: () => void;
  children: ReactNode;
  open?: boolean; // Optional for custom styling
  className?: string; // Optional for custom styling
}

const Dropdown: React.FC<DropdownProps> = ({ onClose, children, className, open }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Close the dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (open && dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        event.stopPropagation();
        event.preventDefault();
        onClose();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [onClose, open]);

  return (
    <div ref={dropdownRef} className={`dropdown-options top-[100%] mt-2 absolute w-full bg-white p-1 rounded-md shadow-elevation-2 border border-gray-7 ${className}`}>
      {children}
    </div>
  );
};

export default Dropdown;